import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeModule } from './home/home.module';
import { PersonnelModule } from './personnel/personnel.module';
import { RegionsModule } from './regions/regions.module';
import { ReportsModule } from './reports/reports.module';
import { ConfigModule } from './config/config.module';
import { CommissionModule } from './commission/commission.module';
import { AdminPortalModule } from './admin-portal/admin-portal.module';
import { ReportFrameworkModule } from './report-framework/report-framework.module';
import { CommissionSummaryModule } from './commission-summary/commission-summary.module';
import { OnlinecalcModule } from './onlinecalc/onlinecalc.module';
import { UploadsModule } from './uploads/uploads.module';
import { LoginModule } from './login/login.module';
import { LoginComponent } from './login/login/login.component';
import { HomeComponent } from './home/home/home.component';
//import { SupersetModule } from './superset/superset.module';

const routes: Routes = [
  { path: 'logind', loadChildren: './login/login.module#LoginModule' },
  { path: 'homemod', loadChildren: './home/home.module#HomeModule' },
  { path: 'personnel', loadChildren: './personnel/personnel.module#PersonnelModule' },
  { path: 'message-management', loadChildren: './message-management/message-management.module#MessageManagementModule' },
  { path: 'regions', loadChildren: './regions/regions.module#RegionsModule' },
  { path: 'reports', loadChildren: './reports/reports.module#ReportsModule' },
  { path: 'config', loadChildren: './config/config.module#ConfigModule' },
  { path: 'commission', loadChildren: './commission/commission.module#CommissionModule' },
  { path: 'admin-portal', loadChildren: './admin-portal/admin-portal.module#AdminPortalModule' },
  { path: 'report-framework', loadChildren: './report-framework/report-framework.module#ReportFrameworkModule' },
  { path: 'commission-summary', loadChildren: './commission-summary/commission-summary.module#CommissionSummaryModule' },
  { path: 'onlinecalc', loadChildren: './onlinecalc/onlinecalc.module#OnlinecalcModule' },
  { path: 'uploads', loadChildren: './uploads/uploads.module#UploadsModule' },
  //{ path: 'superset', loadChildren: './superset/superset.module#SupersetModule' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), ReportFrameworkModule,LoginModule, HomeModule, ConfigModule,
    PersonnelModule, RegionsModule, ReportsModule, CommissionModule, AdminPortalModule,
    CommissionSummaryModule, OnlinecalcModule, UploadsModule],
    //, SupersetModule
  exports: [RouterModule]
})
export class AppRoutingModule { }
